import { Component, OnInit,OnChanges,DoCheck } from '@angular/core';
import {FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import {Location} from '@angular/common';
import { ControlService } from 'src/app/services/control/control.service';
import { MessageService } from 'primeng/api';
import { UserLoginService } from 'src/app/services/UserLogin/userLoginService';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Router } from '@angular/router';
import { EmailService } from 'src/app/services/email/emailService';

@Component({
  selector: 'app-crear-control',
  templateUrl: './crear-control.component.html',
  styleUrls: ['./crear-control.component.css']
})
export class CrearControlComponent implements OnInit,DoCheck {
 public createControlForm:FormGroup;
 public createControlProduct:any=[];
 public myMonth="";
 public user:any;
  public todos:any;
  public disabled=false;
 
  constructor(
    private location:Location,
    private controlService:ControlService,
    private messageService:MessageService,
    private usuarioLoginName:UserLoginService,
    private router:Router,
    private emailService:EmailService
    ){
   
  }
  
  
  ngOnInit(): void {
    this.user=StorageManager.getUser();
    this.iniciar();
  }
 
  ngDoCheck(){
    this.cambiarMes();
   // this.iniciar();
   if(this.createControlForm.controls.todos.value==true){

   }
  }
  comprobar(value){
    console.log(value.checked);
    if(value.checked){
      this.createControlForm.patchValue({
        zona1:true,
        zona2:true,
        zona3:true,
        zona4:true,
        zona5:true,
        zona6:true,
        zona7:true,
        zona8:true,
        zona9:true,
      })
    }else{
      this.createControlForm.patchValue({
        zona1:false,
        zona2:false,
        zona3:false,
        zona4:false,
        zona5:false,
        zona6:false,
        zona7:false,
        zona8:false,
        zona9:false,
      })
    }
  }
  iniciar(){
  
    this.createControlForm=new FormGroup({
      fecha:new FormControl(this.fecha(),Validators.required),
      mes:new FormControl( this.myMonth),
      zona1:new FormControl(false),
      zona2:new FormControl(false),
      zona3:new FormControl(false),
      zona4:new FormControl(false),
      zona5:new FormControl(false),
      zona6:new FormControl(false),
      zona7:new FormControl(false),
      zona8:new FormControl(false),
      zona9:new FormControl(false),
      fechaoperario:new FormControl(this.fecha()),
      nombreoperario:new FormControl(''),
      revisado_fecha:new FormControl(this.fecha()),
      revisado_nombre:new FormControl(this.user.name),
      observaciones:new FormControl(''),
      todos:new FormControl(false), 
    });
  }
  onSubmit(){
    this.createControlForm.patchValue({
      mes:this.myMonth
    });
    // console.log(this.createControlForm.value);
    this.controlService.createControl(this.createControlForm.value).subscribe( resp => {
      // console.log(resp);
      this.messageService.add({severity:'success', summary:'Registro', detail:'Registro guardado correctamente'});
      let observaciones: string = this.createControlForm.controls.observaciones.value;
      if(observaciones === null || observaciones === undefined || observaciones.length == 0 ){

      }else{
        this.emailService.sendMessage(this.createControlForm.value,'CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES').toPromise().then(data =>{
         // console.log('data', data);
        }).catch( error => {
          console.log('error message', error);
        });
      }
      setTimeout(function() {
        this.router.navigate(['dashboard/control']);

      }.bind(this),1000); 
    },error=>{
      console.log(error);
      this.messageService.add({severity:'error', summary:'Registro', detail:'Error en el registro '+error+''});
    });
  }

  cambiarMes() {
    let fecha = this.createControlForm.controls.fecha.value;
    let posiciones = fecha.split("-");
    this.myMonth = this.seleccionarMes(parseInt(posiciones[1]));
    this.createControlForm.patchValue({
      'mes':this.myMonth,
    })

  }
  seleccionarMes(mes){
    let month="";
      switch(mes) {
      case 1:
      month="Enero";
      break;
      case 2:
      month="Febrero";
      break;
      case 3:
      month="Marzo";
      break;
      case 4:
      month="Abril";
      break;
      case 5:
      month="Mayo";
      break;
      case 6:
      month="Junio";
      break;
      case 7:
      month="Julio";
      break;
      case 8:
      month="Agosto";
      break;
      case 9:
      month="Septiembre";
      break;
      case 10:
      month="Octubre";
      break;
      case 11:
      month="Noviembre";
      break;
      case 12:
      month="Diciembre";
      break;
      default:
     
  }
  return month;
  }
  fecha(){
    let today = new Date();
    
    let dd = today.getDate();
 
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
    var MM="";
  var DD="";
  if(mm<10){
    MM=(0).toString()+mm.toString();
  }else{
    MM=mm.toString();
  }

  if(dd<10){
    DD=(0).toString()+dd.toString();
  }else{
    DD=dd.toString();
  }
 
 
  let myfecha = mm + '/' + dd + '/' + yyyy;
  myfecha=yyyy+'-'+MM + '-' + DD ;
  //console.log("fecha ",myfecha);
  return myfecha;
   }

   
  regresar(){
    this.location.back();
  }

  RevisarUsuarioLogueado(){
    //console.log("session ",localStorage.getItem('calidad_user_tag_1'));
    let userLogin=localStorage.getItem('calidad_user_tag_1').replace(/["']/g, "");
    //userLogin=userLogin.replace(/\"/g, "");
    let numUserNameLogin=userLogin.indexOf("name");
    userLogin = userLogin.substring(numUserNameLogin+(5),userLogin.length)
   
    return userLogin;
  }

}
